import React from 'react'

import Header from '../layout/Header'
import Footer from '../layout/Footer'

const DataProtectionPage = ({history}) => (
    <React.Fragment>
        <Header />
        <div className="page mam-spacers">
            <section className="data-protection">
                <h2>
                    Datenschutzhinweise Miles & More MAM-Campaign
                </h2>

                <p>
                    Wir wissen, wie wichtig Ihnen der Schutz Ihrer personenbezogenen Daten ist. Ihr Vertrauen in den sorgfältigen und verantwortungsvollen Umgang Ihrer personenbezogenen Daten hat für uns einen hohen Stellenwert.
                </p>

                <p>
                    In diesen Datenschutzhinweisen erläutern wir Ihnen, welche Informationen während Ihres Besuchs und Ihrer Nutzung unserer Webseite Miles & More MAM-Campaign („Webseite“) erhoben und wie diese Informationen verarbeitet und genutzt werden.
                </p>

                <p>
                    „<strong>Wir</strong>“ bezeichnet die Miles & More GmbH („<strong>MMG</strong>“) als Betreiberin des Miles & More Programms, die zugleich „verantwortliche Stelle“ für die Erhebung, Verarbeitung und Nutzung ihrer personenbezogenen Daten im Sinne der Datenschutzgrundverordnung der Europäischen Union („<strong>DSGVO</strong>“) und des Bundesdatenschutzgesetzes („<strong>BDSG</strong>“) und „Diensteanbieter“ für die Webseite im Sinne des Telemediengesetzes („<strong>TMG</strong>“) ist. Die vollständigen Angaben zu der MMG finden Sie im Impressum unter <a target="_blank" rel="noopener noreferrer" href="http://www.miles-and-more.com/">www.miles-and-more.com</a>.
                </p>
                <ol>

                    <h4>
                        <li>Allgemeine Grundsätze</li>
                    </h4>
                    <p>
                        Wir erheben und verwenden Ihre personenbezogenen Daten grundsätzlich nur, soweit dies zur Bereitstellung der Website erforderlich ist. Eine Erhebung und Verwendung personenbezogener Daten zu anderen Zwecken erfolgt regelmäßig nur
                    </p>
                    <ul className="mb-sm">
                        <li>nach Einwilligung des Nutzers, Art. 6 Abs. 1 lit. a DSGVO</li>
                        <li>wenn die Verarbeitung zum Zwecke der Vertragserfüllung, Art. 6 Abs. 1 lit. b DSGVO oder</li>
                        <li>zur Wahrung berechtigter Interessen, Art. 6 Abs. 1 lit. f DSGVO.</li>
                    </ul>

                    <h4>
                        <li>Umgang mit Daten beim Zugriff auf die Webseite</li>
                    </h4>

                    <p>
                        Sie können unsere Webseite nutzen, ohne direkt personenbezogene Daten (wie etwa Ihren Namen, Ihre Postanschrift oder Ihre E-Mail-Adresse) anzugeben.
                    </p>

                    <p>
                        Auf unserer Webseite setzen wir bestimmte Analyseverfahren ein und haben zusätzlich Funktionalitäten zur Einbindung sozialer Netzwerke integriert. Im Folgenden werden die Analyseverfahren und Einbindungen erläutert.
                    </p>

                    <ol>
                        <h6><li>Cookies</li></h6>

                        <p>
                            Um unser Angebot so nutzerfreundlich wie möglich zu gestalten, verwenden wir – wie viele namenhafte Unternehmen – sogenannte Cookies.
                        </p>

                        <p>
                            Bei einem „Cookie“ (englisch für „Keks“) handelt es sich um eine kleine Textdatei, die ein Webserver (also z.B. der Webserver von <a target="_blank" rel="noopener noreferrer" href="http://www.miles-and-more.com/">www.miles-and-more.com</a>) an Ihren Browser sendet, wenn Sie eine Webseite besuchen. Die sogenannten „Session Cookies“ laufen am Ende der Browsersitzung ab und können Ihre Aktionen während dieser einen Browsersitzung erfassen.
                        </p>
                        <p>
                            Demgegenüber bleiben „permanente Cookies“ auch zwischen verschiedenen Browsersitzungen auf Ihrem Endgerät gespeichert und können Ihre Einstellungen oder Aktionen auf mehreren Webseiten erfassen.
                        </p>
                        <p>
                            Neben so genannten „Session-Cookies“, die gelöscht werden, wenn Sie Ihre Browsersitzung beenden, setzen wir permanente Cookies für Zwecke der Analyse mit Adobe Analytics ein, die bis zur Löschung durch den Nutzer gespeichert werden.
                        </p>
                        <p>
                            Je nach Einstellung Ihres Browsers wird die Cookie-Datei gespeichert oder abgelehnt. Wird die Datei gespeichert, kann unser Webserver Ihr Endgerät wiedererkennen. Bei späteren Besuchen und bei Wechseln zwischen Funktionen, die von Ihnen eine Passworteingabe erfordern, können Sie sich durch den Cookie einige Eingaben sparen. Dadurch erleichtern Ihnen Cookies die Benutzung von Webseiten, die Benutzereingaben erfordern. Zusätzlich können Cookies uns helfen, Ihnen ein möglichst individualisiertes und relevantes Surferlebnis zu bieten, sofern Sie uns die Einwilligung dazu erteilen.
                        </p>
                        <p>
                            Unabhängig von gespeicherten Cookies müssen Sie sich aus Sicherheitsgründen für jeden Zugriff auf registrierungspflichtige Bereiche auf unserer Webseite neu anmelden; auch das Einlösen von Meilen erfordert eine vorherige Passworteingabe.
                        </p>
                        <p>
                            In den von uns verwendeten Cookies werden keine personenbezogenen Daten gespeichert: Denn diesen Cookies wird jeweils nur eine Identifikationsnummer zugewiesen, die wir ohne Ihre Einwilligung nicht mit den sonstigen ggf. bei uns vorhandenen Daten (etwa aufgrund einer Registrierung) zusammenführen werden.
Sie können Ihren Browser entweder so einstellen, dass er unsere Cookies empfangen kann oder unsere Website ohne Cookie-Funktionalität nutzen. In letzterem Fall jedoch können Ihre Texteingaben in Formularfelder für weitere Abfragen nicht gespeichert werden, so dass beim nächsten Besuch unserer Website erneute Eingaben erforderlich sind. Weiterhin können wir Ihnen in diesem Fall leider keine auf Sie persönlich zugeschnittenen Inhalte präsentieren.
                        </p>
                        <p>
                            Möglicherweise ist Ihr Browser auch bereits so eingestellt, dass er jedes Mal eine Warnmeldung anzeigt, wenn er ein Cookie empfängt. Da beim Aufruf jeder einzelnen Seite unserer Webseite das Identifizierungs-Cookie neu gesendet werden muss, kann diese Meldung sehr störend sein. Wir empfehlen Ihnen daher, in Ihrem Browser einzustellen, dass Cookies von <a target="_blank" rel="noopener noreferrer" href="http://www.miles-and-more.com/">www.miles-and-more.com</a> immer zugelassen werden. Sie können diese Einstellung für einzelne Webseiten individuell festlegen.
                        </p>
                        <p>
                            Weitere Informationen zum Einsatz von Cookies sowie dazu, wie Sie Cookies deaktivieren können, finden Sie unter <a target="_blank" rel="noopener noreferrer" href="http://www.meine-cookies.org/">meine-cookies.org</a> oder <a target="_blank" rel="noopener noreferrer" href="https://youronlinechoices.com/">youronlinechoices.com</a>.
                        </p>
                    </ol>


                    <h4>
                        <li>
                            Umgang mit Daten bei Nutzung von Miles & More MAM-Campaign
                        </li>
                    </h4>
                    <ol>
                        <h6><li>Nutzung von Miles & More MAM-Campaign</li></h6>
                        <p>
                            Im Rahmen der Nutzung der Webseite werden grundsätzlich keine personenbezogenen Daten erhoben. Dies kann allein aus berechtigtem Interesse wie insbesondere der Abwehr für Gefahren für die MMG erfolgen, Art. 6 Abs. 1 lit. f DSGVO.
                        </p>

                        <h6><li>Verweise und Datenerhebung auf Webseiten Dritter</li></h6>
                        <p>
                            Über Verlinkungen auf unserer Webseite können Sie auf Webseiten Dritter gelangen, die nicht von uns betrieben werden. Hierbei kann es sich z.B. um Webseiten von Partnerunternehmen handeln, bei denen Sie Meilen sammeln können oder die spezielle Angebote für Miles & More Teilnehmer bereitstellen. Auf die Erhebung, Verarbeitung und Nutzung Ihrer personenbezogenen Daten auf solchen Webseiten Dritter haben wir keinen Einfluss, diese werden vielmehr durch den Anbieter der jeweiligen Webseite vorgenommen. Bitte lesen Sie deshalb die Nutzungsbedingungen und Datenschutzinformationen auf diesen Webseiten, um genauere Informationen zur Erhebung, Verarbeitung und Nutzung von (personenbezogenen) Informationen auf diesen Webseiten zu erhalten.
                        </p>
                    </ol>

                    <h4>
                        <li>
                            Datenschutzhinweise Miles & More Programm
                        </li>
                    </h4>
                    <p>
                        Weitere Informationen zum Umgang mit Ihren Daten im Miles & More Programm sowie insbesondere zu Ihren Rechten, zur Einwilligung und zu den Kontaktmöglichkeiten finden Sie unter <a target="_blank" rel="noopener noreferrer" href="http://www.miles-and-more.com/datenschutz">www.miles-and-more.com/datenschutz</a>.
                    </p>

                    <h4>
                        <li>
                            Aktualisierung
                        </li>
                    </h4>
                    <p>
                        Wir überprüfen diese Datenschutzhinweise regelmäßig und werden diese bei Bedarf aktualisieren. Über wesentliche Änderungen dieser Datenschutzhinweise werden wir Sie informieren.
                    </p>

                </ol>
                <p>
                    <button onClick={history.goBack}>Back</button>
                </p>
            </section>
        </div>
        <Footer />
    </React.Fragment>
)

export default DataProtectionPage



// WEBPACK FOOTER //
// ./src/components/pages/DataProtectionPage.js